// extracted by mini-css-extract-plugin
module.exports = {"list":"PostListing-module__list___1_cPe","item":"PostListing-module__item___1rkM9"};